import { API_BASE_URL } from '@/types/setup';
import { attachTraceId } from '@/utils/traceId';
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  withCredentials: true,
});

attachTraceId(axiosInstance);

/**
 * The websocket server's /emit-message endpoint — root-relative (not under the
 * router's API_BASE_URL) and JSON, so it can't share the instance above. It also
 * must not pick up setupInterceptors' router_id/userid injection, which would
 * corrupt the JSON body.
 */
export const emitMessageApi = axios.create({
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

attachTraceId(emitMessageApi);

export default axiosInstance;
